import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { host_url } from '../../App'; // Import host_url
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import './EinheitenAktivieren.css'; // We will create this file later for styling

const EinheitenAktivieren = () => {
    const [einheiten, setEinheiten] = useState([]);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchEinheiten();
    }, []);

    const fetchEinheiten = async () => {
        try {
            const response = await axios.get(`${host_url}/einheiten`);
            // Ensure that response.data is an array before setting it
            if (Array.isArray(response.data)) {
                setEinheiten(response.data);
            } else {
                // If not an array (e.g., null, object), set to empty array to prevent crash
                setEinheiten([]);
                console.warn('API /einheiten did not return an array, got:', response.data);
            }
        } catch (error) {
            console.error('Fehler beim Abrufen der Einheiten:', error);
            setError('Fehler beim Laden der Einheiten.');
        }
    };

    // 0 = gesperrt, 1 = Automatik (Zeitfenster 24 h vor Beginn bis Beginn), 2 = manuell geöffnet
    const setAktivStatus = async (id, newStatus) => {
        try {
            await axios.put(`${host_url}/einheiten/${id}/aktiv`, { aktiv: newStatus });
            setMessage('Status erfolgreich aktualisiert.');
            // Refresh the list
            fetchEinheiten();
            // Hide message after 3 seconds
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            console.error('Fehler beim Aktualisieren des Status:', error);
            setError('Fehler beim Aktualisieren des Status.');
            setTimeout(() => setError(''), 3000);
        }
    };

    const statusLabel = (aktiv) => {
        if (aktiv === 0) return 'Gesperrt';
        if (aktiv === 2) return 'Manuell geöffnet';
        return 'Automatik';
    };

    return (
    <KernteamLayout>
        <div className="container">
            <BackArrow to="/arbeit" color="gelb" />
            <h1 className="section-title orange">Einheiten aktivieren/deaktivieren</h1>
            <p className="ea-description">
                <strong>Automatik:</strong> Bewerbung am Terminal ist von 24 Stunden vor
                Schichtbeginn bis zum Beginn möglich. <strong>Manuell geöffnet:</strong> Bewerbung
                ist immer möglich (auch nach Beginn). <strong>Gesperrt:</strong> Bewerbung ist nie möglich.
            </p>
            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}
            <div className="einheiten-table-wrapper">
                <table className="einheiten-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Datum</th>
                            <th>Status</th>
                            <th>Aktion</th>
                        </tr>
                    </thead>
                    <tbody>
                        {einheiten.map((einheit) => (
                            <tr key={einheit.ID}>
                                <td>{einheit.Name}</td>
                                <td>{new Date(einheit.Datum).toLocaleDateString('de-DE')}</td>
                                <td>{statusLabel(einheit.Aktiv)}</td>
                                <td>
                                    <div className="ea-status-buttons">
                                        <button
                                            className={`ea-status-btn ${einheit.Aktiv === 1 ? 'active' : ''}`}
                                            onClick={() => setAktivStatus(einheit.ID, 1)}
                                        >
                                            Automatik
                                        </button>
                                        <button
                                            className={`ea-status-btn ${einheit.Aktiv === 2 ? 'active' : ''}`}
                                            onClick={() => setAktivStatus(einheit.ID, 2)}
                                        >
                                            Öffnen
                                        </button>
                                        <button
                                            className={`ea-status-btn ${einheit.Aktiv === 0 ? 'active' : ''}`}
                                            onClick={() => setAktivStatus(einheit.ID, 0)}
                                        >
                                            Sperren
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </KernteamLayout>
    );
};

export default EinheitenAktivieren;
